import type { FC } from 'react';

import { shipmentTypeOptions } from '@zen/Booking/helpers';
import type { FormFieldProps } from '@zen/Components/Form/FormField';

import FormSelect from '../FormSelect';

interface Props extends FormFieldProps {}

const FormShipmentTypeSelect: FC<Props> = (props) => {
  return <FormSelect {...props} options={shipmentTypeOptions} placeholder="Select shipment type" />;
};

export default FormShipmentTypeSelect;
